import { ChangeDetectionStrategy, Component, InjectionToken, Input, inject } from '@angular/core';
import { Observable, of } from 'rxjs';

export type ChipValueToStringFn = (val: unknown) => Observable<string>;
export const CHIP_VALUE_TO_STRING_FN = new InjectionToken<ChipValueToStringFn>('IrisFilterDefaultChipItemViewComponent - Chip value to string fn');

@Component({
  selector: 'iris-filter-default-chip-item-view',
  templateUrl: './default-chip-item-view.component.html',
  styleUrls: ['./default-chip-item-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IrisFilterDefaultChipItemViewComponent {
  readonly chipValueToStringFn = inject<ChipValueToStringFn>(CHIP_VALUE_TO_STRING_FN, { optional: true }) ?? ((val: never) => of(String(val)));

  @Input() text$: Observable<string>;
  @Input() maxWidth: number;
}
